module.exports = __webpack_public_path__ + "img/mind_skeleton_23.25ed7aca.png";